export function sleep(timeout: number) {
    return new Promise((resolve) => {
        setTimeout(resolve, timeout)
    })
}

export function withLoading<T extends { loading: boolean }, F>(self: T, p: Promise<F>, useLoading = true): Promise<F> {
    if (!useLoading) {
        return p
    }
    self.loading = true
    return p.finally(() => {
        self.loading = false
    })
}

export function withFieldLoading<T extends object, F extends keyof T, K>(self: T, p: Promise<K>, field: F): Promise<K> {
    (self[field] as any) = true
    return p.finally(() => {
        (self[field] as any) = false
    })
}

export class TaskSource<T> {
    _promise: Promise<T>
    _resolve!: (t: T) => void
    _reject!: (e?: Error) => void
    _fired = false
    constructor() {
        this._promise = new Promise<T>((resolve, reject) => {
            this._resolve = resolve
            this._reject = reject
        })
    }

    get Promise() {
        return this._promise
    }

    Resolve(t?: T) {
        if (this._fired) {
            console.error('Can not Resolve fired source')
            return false
        }
        this._fired = true
        this._resolve(t as T)
        return true
    }

    // todo
    TryResolve(t?: T) {
        if (this._fired) {
            return false
        }
        return this.Resolve(t)
    }

    Reject(e?: Error) {
        if (this._fired) {
            console.error('Can not Resolve fired source')
            return false
        }
        this._fired = true
        this._reject(e)
        return true
    }

    TryReject(e?: Error) {
        if (this._fired) {
            return false
        }
        return this.Reject(e)
    }

    get Fired() {
        return this._fired
    }
}
